import React from 'react';

const PartnerCard = ({ logo, name, description, url }) => {
  return (
    <div className="partner-card">
      <div className="partner-logo">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <img src={logo} alt={`${name} Logo`} />
        </a>
      </div>
      <div className="partner-info">
        <h3>{name}</h3>
        <p>{description}</p>
        <div className="partner-link">
          <a href={url} target="_blank" rel="noopener noreferrer" className="btn secondary">Siteyi Ziyaret Et</a>
        </div>
      </div>
    </div>
  );
};

const References = () => {
  const partnerData = [
    {
      logo: "https://cheatglobal.com/styles/xenfocus/cheatglobal-logo.png",
      name: "CheatGlobal.com",
      description: "Premium oyun geliştirme çözümleri ve güvenlik bypass sistemleri. Oyuncular için geniş bir tespit edilemeyen araç yelpazesi sunan güvenilir ortağımız.",
      url: "https://cheatglobal.com"
    }
  ];

  return (
    <section id="references" className="references">
      <div className="container">
        <div className="section-header">
          <h2>İş Ortağı <span className="accent">Siteler</span></h2>
          <p>İşbirliği yaptığımız ve önerdiğimiz platformlar</p>
        </div>
        <div className="partner-sites">
          {partnerData.map((partner, index) => (
            <PartnerCard 
              key={index}
              logo={partner.logo}
              name={partner.name}
              description={partner.description}
              url={partner.url}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default References; 